import { render, staticRenderFns } from "./vigilante.vue?vue&type=template&id=348cfd20&scoped=true"
import script from "./vigilante.vue?vue&type=script&lang=js"
export * from "./vigilante.vue?vue&type=script&lang=js"
import style0 from "./vigilante.vue?vue&type=style&index=0&id=348cfd20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348cfd20",
  null
  
)

export default component.exports